import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import UpgradeModal from '../components/UpgradeModal';

interface UpgradeModalContextValue {
  openUpgradeModal: () => void;
  closeUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalContextValue | undefined>(undefined);

export const UpgradeModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openUpgradeModal = useCallback(() => setIsOpen(true), []);
  const closeUpgradeModal = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ openUpgradeModal, closeUpgradeModal }),
    [openUpgradeModal, closeUpgradeModal]
  );

  return (
    <UpgradeModalContext.Provider value={value}>
      {children}
      <UpgradeModal isOpen={isOpen} onClose={closeUpgradeModal} />
    </UpgradeModalContext.Provider>
  );
};

export function useUpgradeModal(): UpgradeModalContextValue {
  const ctx = useContext(UpgradeModalContext);
  if (ctx === undefined) {
    throw new Error('useUpgradeModal must be used within UpgradeModalProvider');
  }
  return ctx;
}
